export const AGORA_APP_ID = 'aefab4223e9e49c8a9142aa0a7516684';
